import React from "react";
import KnowledgeBackedProfileChapter from "./KnowledgeBackedProfileChapter";

// What Helps-specific classification, grouping, and copy stay in
// whatHelpsDomain.js. Shared Profile lifecycle stays in the reusable shell.
const ProfileWhatHelpsChapter = (props) => (
  <KnowledgeBackedProfileChapter {...props} presentationMode="profileItems" />
);

export default ProfileWhatHelpsChapter;
